import React from 'react'

export default function Content({ children }) {
  return <div className="accordion border rounded border-primary mb-2">{children}</div>
}
